import axios from "axios";

// Use RELATIVE URLs so API calls go to the same host that serves the page.
// This prevents CORS issues when the site is accessed via multiple hostnames
// (e.g. useko.org vs www.useko.org). The env var is kept only to repair
// legacy stored URLs that had an absolute host baked in.
const LEGACY_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = "/api";

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 30000,
});

// Attach bearer token if present in localStorage (fallback for httpOnly cookie)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("useko_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(path) {
  if (!path) return "";
  // Absolute URL pointing to our own API files → strip host, use relative path
  // (repairs old records saved with a previous BACKEND_URL and avoids CORS).
  if (path.startsWith("http")) {
    try {
      const u = new URL(path);
      if (u.pathname.startsWith("/api/files/") || u.pathname.startsWith("/api/uploads/")) {
        return `${u.pathname}${u.search}`;
      }
      return path;
    } catch {
      return path;
    }
  }
  return path;
}
